var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.psInfo
      ? _c("div", { staticClass: "acea-row row-middle border_bottom pb-24" }, [
          _c("div", { staticClass: "avatar mr20" }, [
            _c("img", { attrs: { src: _vm.psInfo.user.avatar } }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard-workplace-header-tip" }, [
            _c("p", { staticClass: "dashboard-workplace-header-tip-title" }, [
              _c("span", [_vm._v("昵称：" + _vm._s(_vm.psInfo.user.nickname))]),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-left": "20px" } }, [
                _vm._v("手机号：" + _vm._s(_vm.psInfo.user.phone)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dashboard-workplace-header-tip-desc" }, [
              _vm.customConfig.enableRecharge == 1
                ? _c(
                    "span",
                    {
                      staticClass:
                        "dashboard-workplace-header-tip-desc-sp pb-1",
                    },
                    [_vm._v("余额: " + _vm._s(_vm.psInfo.balance))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "dashboard-workplace-header-tip-desc-sp pb-1" },
                [_vm._v("总计订单: " + _vm._s(_vm.psInfo.allOrderCount))]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "dashboard-workplace-header-tip-desc-sp pb-1" },
                [_vm._v("总消费金额: " + _vm._s(_vm.psInfo.allConsumeCount))]
              ),
              _vm._v(" "),
              _vm.customConfig.enablePoints == 1
                ? _c(
                    "span",
                    { staticClass: "dashboard-workplace-header-tip-desc-sp" },
                    [_vm._v(" 积分: " + _vm._s(_vm.psInfo.integralCount))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "dashboard-workplace-header-tip-desc-sp" },
                [_vm._v("本月订单: " + _vm._s(_vm.psInfo.mothOrderCount))]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "dashboard-workplace-header-tip-desc-sp" },
                [_vm._v("本月消费金额: " + _vm._s(_vm.psInfo.mothConsumeCount))]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "top-tabs mt20" },
      [
        _c(
          "el-menu",
          {
            staticClass: "horizontal-menu",
            attrs: { "default-active": _vm.tableFrom.type, mode: "horizontal" },
            on: { select: _vm.changeType },
          },
          _vm._l(_vm.list, function (item, index) {
            return _c(
              "el-menu-item",
              {
                key: index,
                class: { "is-active": _vm.tableFrom.type === item.val },
                attrs: { index: item.val },
              },
              [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-container" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "tabNumWidth",
            attrs: {
              border: true,
              data: _vm.tableData.data,
              "max-height": "400",
            },
          },
          _vm._l(_vm.columns, function (item, index) {
            return _c("el-table-column", {
              key: index,
              attrs: {
                prop: item.key,
                label: item.title,
                "min-width": item.minWidth,
                "show-overflow-tooltip": true,
              },
              scopedSlots: _vm._u(
                [
                  _vm.tableFrom.type == 0 && item.key === "bizType"
                    ? {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(_vm.translate(scope.row.bizType))),
                            ]),
                          ]
                        },
                      }
                    : _vm.tableFrom.type == 0 && item.key === "totalPrice"
                    ? {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.$selfUtil.isUsePriceBiz(scope.row.bizType)
                              ? _c("span", [
                                  _vm._v(_vm._s(scope.row.totalPrice)),
                                ])
                              : scope.row.bizType === 2
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(scope.row.pointsPayPrice) + "积分"
                                  ),
                                ])
                              : _c("span", [_vm._v("--")]),
                          ]
                        },
                      }
                    : _vm.tableFrom.type == 1 && item.key === "type"
                    ? {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.type === 1
                              ? _c("span", [_vm._v("增加")])
                              : scope.row.type === 2
                              ? _c("span", [_vm._v("扣减")])
                              : _c("span", [_vm._v("--")]),
                          ]
                        },
                      }
                    : _vm.tableFrom.type == 1 && item.key === "integral"
                    ? {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.type === 1
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("+ " + _vm._s(scope.row.integral)),
                                ])
                              : scope.row.type === 2
                              ? _c(
                                  "span",
                                  { staticStyle: { color: "green" } },
                                  [_vm._v("- " + _vm._s(scope.row.integral))]
                                )
                              : _c("span", [_vm._v("--")]),
                          ]
                        },
                      }
                    : null,
                ],
                null,
                true
              ),
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("el-pagination", {
              attrs: {
                "page-sizes": [6, 12, 18, 24],
                "page-size": _vm.tableFrom.limit,
                "current-page": _vm.tableFrom.page,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.tableData.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.pageChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }